"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _excluded = ["input", "allowNegative", "customChange", "decimalPlaces", "maxAmount", "anchored", "customClass", "innerComponent", "allowBigNumber"],
  _excluded2 = ["enableMax"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BaseNumberInput = function BaseNumberInput(_ref) {
  var input = _ref.input,
    _ref$allowNegative = _ref.allowNegative,
    allowNegative = _ref$allowNegative === void 0 ? false : _ref$allowNegative,
    _ref$customChange = _ref.customChange,
    customChange = _ref$customChange === void 0 ? function () {} : _ref$customChange,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 8 : _ref$decimalPlaces,
    _ref$maxAmount = _ref.maxAmount,
    maxAmount = _ref$maxAmount === void 0 ? '0' : _ref$maxAmount,
    _ref$anchored = _ref.anchored,
    anchored = _ref$anchored === void 0 ? null : _ref$anchored,
    customClass = _ref.customClass,
    InnerInput = _ref.innerComponent,
    allowBigNumber = _ref.allowBigNumber,
    passedProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(input.value),
    _useState2 = _slicedToArray(_useState, 2),
    displayValue = _useState2[0],
    setDisplayValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (input.value !== displayValue) {
      // Only update displayValue if it's different from input.value
      setDisplayValue(input.value.toString());
    }
  }, [input.value, displayValue]);
  var handleChange = (0, _react.useCallback)(function (e) {
    var inputValue = e.target.value;

    // Allow starting with a decimal point by converting it to "0."
    if (inputValue === '.') {
      inputValue = '0.';
    }

    // Prevent non-numeric input, except for a single decimal point
    var regex = /^[0-9]*\.?[0-9]*$/;
    if (!regex.test(inputValue)) {
      // If the input is invalid (contains invalid characters), do not update the state and return
      return;
    }

    // Prevent multiple leading zeros in the integer part, except "0."
    if (/^0{2,}/.test(inputValue) && !inputValue.includes('.')) {
      inputValue = inputValue.replace(/^0+/, '0'); // Replace extra leading zeros
    }

    // Prevent leading zeros except when followed by a decimal point
    if (inputValue.startsWith('0') && !inputValue.startsWith('0.') && inputValue.length > 1) {
      inputValue = inputValue.replace(/^0+/, '');
    }

    // Handle BigNumber validation for large values and allow decimals without scientific notation
    if (allowBigNumber && new _bignumber["default"](inputValue).isGreaterThan(Number.MAX_SAFE_INTEGER)) {
      var _inputValue$split = inputValue.split('.'),
        _inputValue$split2 = _slicedToArray(_inputValue$split, 2),
        integerPart = _inputValue$split2[0],
        _inputValue$split2$ = _inputValue$split2[1],
        decimalPart = _inputValue$split2$ === void 0 ? '' : _inputValue$split2$;
      var combinedValue = decimalPart.length > decimalPlaces ? "".concat(integerPart, ".").concat(decimalPart.slice(0, decimalPlaces)) : inputValue;
      setDisplayValue(combinedValue);
      input.onChange(combinedValue);
      if (customChange) {
        customChange(combinedValue);
      }
      return;
    }

    // Restrict the number of decimal places based on decimalPlaces prop
    var decimalIndex = inputValue.indexOf('.');
    if (decimalIndex !== -1) {
      var decimals = inputValue.slice(decimalIndex + 1);
      if (decimals.length > decimalPlaces) {
        return; // Prevent further input if the number of decimal places exceeds the limit
      }
    }

    // Update displayValue with the valid input
    setDisplayValue(inputValue);

    // Only process if it is a valid number and not NaN
    if (inputValue !== '' && !isNaN(parseFloat(inputValue))) {
      input.onChange(inputValue); // Pass the inputValue directly

      if (customChange) {
        customChange(inputValue);
      }
    } else if (inputValue === '') {
      // Allow clearing the input field
      setDisplayValue('');
      input.onChange('');
      if (customChange) {
        customChange('');
      }
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [allowNegative, allowBigNumber, customChange, decimalPlaces, input]);
  var handleFocus = (0, _react.useCallback)(function () {
    if (new _bignumber["default"](displayValue).isNaN() || new _bignumber["default"](displayValue).isEqualTo(0)) {
      input.onChange('');
    } else {
      var _displayValue$split$;
      var bigNumberValue = new _bignumber["default"](displayValue);
      var decimalPart = (_displayValue$split$ = displayValue.split('.')[1]) !== null && _displayValue$split$ !== void 0 ? _displayValue$split$ : '';
      if (decimalPart.length > 0) {
        var trimmedValue = bigNumberValue.toFixed(decimalPart.length, _bignumber["default"].ROUND_DOWN);
        setDisplayValue(trimmedValue);
        input.onChange(trimmedValue);
      } else {
        var finalValue = bigNumberValue.toFixed();
        setDisplayValue(finalValue);
        input.onChange(finalValue);
      }
    }
  }, [displayValue, input]);
  var handleMaxClick = (0, _react.useCallback)(function () {
    var maxAmountValue = Number(maxAmount.replace(/,/g, '')) || 0;
    var maxAmountString = maxAmountValue.toString();
    if (input.value !== maxAmountString) {
      setDisplayValue(maxAmountString);
      input.onChange(maxAmountValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.value, maxAmount]);

  // Remove enableMax from passedProps to prevent it from being passed to a DOM element
  var enableMax = passedProps.enableMax,
    restProps = _objectWithoutProperties(passedProps, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(InnerInput, _extends({
    step: "any"
  }, restProps, {
    placeholder: anchored === false && input.value ? "\u2248 ".concat(input.value) : restProps.placeholder || '',
    customClass: customClass,
    autoComplete: "off",
    type: "text",
    input: _objectSpread(_objectSpread({}, input), {}, {
      value: anchored === false ? '' : displayValue,
      onChange: handleChange,
      onBlur: function onBlur() {
        return input.onBlur();
      }
    }),
    onClick: function onClick() {
      input.onFocus();
      handleFocus('onClick');
    },
    onFocus: handleFocus,
    onMaxClick: handleMaxClick // Pass handleMaxClick as a prop
  }));
};
BaseNumberInput.defaultProps = {
  allowNegative: false,
  allowBigNumber: false,
  anchored: null
};
BaseNumberInput.propTypes = {
  input: _propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func.isRequired,
    onFocus: _propTypes["default"].func.isRequired
  }).isRequired,
  allowNegative: _propTypes["default"].bool,
  allowBigNumber: _propTypes["default"].bool,
  customChange: _propTypes["default"].func,
  decimalPlaces: _propTypes["default"].number,
  maxAmount: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  anchored: _propTypes["default"].bool,
  customClass: _propTypes["default"].string,
  innerComponent: _propTypes["default"].elementType.isRequired
};
var _default = exports["default"] = BaseNumberInput;